import { useState } from 'react'
import { LuArrowRight, LuExternalLink } from 'react-icons/lu'

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import products from '@/config/products'
import { cn } from '@/utils/cn'

const Dot = ({ color }: { color: string }) => (
  <div className='h-3 w-3 rounded-full' style={{ backgroundColor: color }} />
)

const logoContent = (color: string, name: string) => (
  <>
    <span className='flex font-sans text-lg font-bold tracking-wider'>
      hubble
    </span>
    <Dot color={color} />
    <span className='text-md flex font-thin tracking-wide uppercase'>
      {name}
    </span>
  </>
)

const AppName = ({
  color,
  name,
  url,
}: {
  color: string
  name: string
  url?: string
}) =>
  url ? (
    <a
      className='group flex w-full items-center space-x-2'
      href={url}
      target='_blank'
      rel='noopener noreferrer'
    >
      {logoContent(color, name)}
      <LuExternalLink className='ml-[9px] h-4' />
    </a>
  ) : (
    <span className='flex items-center space-x-2'>
      {logoContent(color, name)}
    </span>
  )

const HubbleLogo = () => {
  const [open, setOpen] = useState(false)

  const enabledProducts = products.filter(
    (p) => !p.hidden && !p.comingSoon && p.url,
  )

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger
        className={cn(
          'bg-elements-dark-shadow hover:bg-elements-dark-dimmed text-elements-dark-contrastText hover:text-elements-dark-contrastText/80 focus-visible:ring-elements-dark-highlight -ml-1 flex h-10 w-fit items-center justify-between rounded-none border-none px-1.5 py-0 text-sm ring-offset-0 outline-none focus:outline-none focus-visible:ring-2 disabled:cursor-not-allowed disabled:opacity-50',
          { 'bg-elements-dark-dimmed': open },
        )}
      >
        <img
          src='/images/logo.png'
          alt='Hubble Logo'
          className='mr-2 h-auto w-7'
        />
        <AppName name='Portal' color='#fddb54' />
      </DropdownMenuTrigger>
      <DropdownMenuContent className='border-elements-dark-dimmed bg-elements-dark-shadow text-elements-dark-contrastText -mt-2 min-w-[14rem] space-y-2 rounded-none border py-2'>
        {enabledProducts.map((product) => (
          <DropdownMenuItem
            key={product.id}
            className='group/productSelect hover:bg-elements-dark-dimmed focus:bg-elements-dark-dimmed focus-visible:ring-elements-dark-highlight rounded-none px-[3px] text-white hover:text-white focus:text-white focus-visible:ring-1'
            onSelect={() => {
              if (product.url) {
                window.open(product.url, '_newtab', 'noopener,noreferrer')
              }
            }}
          >
            <LuArrowRight className='mr-3 ml-2 h-4 w-4 opacity-0 transition-all group-hover/productSelect:translate-x-1' />
            <AppName
              name={product.name}
              url={product.url}
              color={product.backgroundColor}
            />
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default HubbleLogo
